import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  place-content: center;
`;

const ReviewCard = styled.div`
  width: 570px;
  box-sizing: border-box;
  padding: 30px;
  border-radius: 40px;
  align-self: flex-start;
  background-color: ${props => props.theme.color.backgroundRush};

  h5 {
    margin-top: 20px;
    margin-bottom: 30px;
  }
`;

const PlanCard = styled.div`
  width: 270px;
  margin-left: 30px;
  padding: 30px;
  border-radius: 40px;
  align-self: flex-start;
  box-sizing: border-box;
  background-color: ${props => props.theme.color.backgroundRush};

  button {
    width: 100%;
  }

  button + p {
    margin-top: 20px;
  }
`;

const AttentionText = styled.div`
  display: flex;
  margin-top: 10px;

  svg {
    height: 20px;
    margin-right: 15px;
    fill: ${props => props.theme.color.green};
  }
`;

const LinkButton = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  color: ${p => p.theme.color[p.color]};
  cursor: pointer;

  svg {
    height: 20px;
    margin-right: 15px;
    fill: currentColor;
  }
`;
const PaymentDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  p {
    margin-top: 10px;
  }
`;

const Period = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  > div {
    margin: 0 10px;
  }
`;

const CancelSubscriptionWarning = styled.div`
  font-family: Light;
  text-align: center;
  word-break: normal;
  line-height: 18px;
`;

export const Styled = {
  Container,
  ReviewCard,
  PlanCard,
  Period,
  LinkButton,
  AttentionText,
  PaymentDetails,
  CancelSubscriptionWarning,
};
